/* eslint-disable */
import React, { useState } from "react";
import "../DropdownlistFilterGlobal/Dropdown.css";
import Filter_Icon from "../icons/Filter_Icon";

const options = [
  "Ver todos",
  "Mes actual",
  "Mes pasado",
  "Año actual",
  "Año pasado",
];

const DropDownListDateRangeFilter = ({
  selectedOption,
  setSelectedOption,
  controlWidth,
}) => {
  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const style_btn = {
    transition: "background-color 0.3s, color 0.3s, transform 0.3s",
    transform: isHovered ? "scale(1.05)" : "scale(1)",
  };
  return (
    <>
      {controlWidth >= 1194 ? (
        <div
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className="dropdown"
          style={style_btn}
        >
          <select value={selectedOption} onChange={handleOptionChange}>
            {options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      ) : (
        <div
          style={{
            border: "1px solid rgb(229, 237, 255",
            heigth: "2rem",
            padding: "10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "10px",
            cursor: "pointer",
            borderRadius: "10px",
          }}
        >
          <Filter_Icon />
          Filtrar
        </div>
      )}
    </>
  );
};

export default DropDownListDateRangeFilter;
